import { useViewNavigation } from '../view-atoms'
import { useActiveBriefContext } from '../components/meeting/brief/atoms'
import { viewContextOf } from '../view-definitions'
import { MEETING_VIEW_ID } from '../components/meeting/meeting-view-id'

type ChatInputMode =
  | {
      mode: 'default'
      stagedActionId: undefined
      stagedActionIds: undefined
      conversationId: undefined
      briefConversationId: undefined
    }
  | {
      mode: 'staged-action'
      stagedActionId: string | undefined
      stagedActionIds: undefined
      conversationId: undefined
      briefConversationId: undefined
    }
  | {
      mode: 'chat-output'
      stagedActionId: undefined
      stagedActionIds: ReadonlyArray<string>
      conversationId: string | undefined
      briefConversationId: undefined
    }
  | {
      mode: 'brief'
      stagedActionId: undefined
      stagedActionIds: undefined
      conversationId: undefined
      briefConversationId: string
    }

export function useChatInputMode(): ChatInputMode {
  const { topView: top } = useViewNavigation()
  const activeBrief = useActiveBriefContext()

  if (top?.id === 'action') {
    return {
      mode: 'staged-action',
      stagedActionId: viewContextOf(top, 'action')?.actionId,
      stagedActionIds: undefined,
      conversationId: undefined,
      briefConversationId: undefined,
    }
  }

  if (top?.id === 'chatOutput') {
    const context = viewContextOf(top, 'chatOutput')
    return {
      mode: 'chat-output',
      stagedActionId: undefined,
      stagedActionIds: context?.stagedActionIds ?? [],
      conversationId: context?.conversationId,
      briefConversationId: undefined,
    }
  }

  if (activeBrief && top?.id === MEETING_VIEW_ID) {
    return {
      mode: 'brief',
      stagedActionId: undefined,
      stagedActionIds: undefined,
      conversationId: undefined,
      briefConversationId: activeBrief.conversationId,
    }
  }

  return {
    mode: 'default',
    stagedActionId: undefined,
    stagedActionIds: undefined,
    conversationId: undefined,
    briefConversationId: undefined,
  }
}
